import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import { ClientReturnItem, CustomHttpResponse } from '../../../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ClientReturnItemService {
  apiService: ApiHttpService<ClientReturnItem> = inject(ApiHttpService<ClientReturnItem>);

  getForClientReturn(iri: string): Observable<ClientReturnItem[]> {
    return this.apiService
      .getMany(`${iri}/client_return_items`)
      .pipe(map((result) => result.body['hydra:member']));
  }

  create(clientReturnItem: ClientReturnItem): Observable<ClientReturnItem> {
    return this.apiService
      .post('/client_return_items', clientReturnItem)
      .pipe(map((result: CustomHttpResponse<ClientReturnItem>) => result.body));
  }

  update(iri: string, clientReturnItem: ClientReturnItem): Observable<ClientReturnItem> {
    return this.apiService
      .patch(iri, clientReturnItem)
      .pipe(map((result: CustomHttpResponse<ClientReturnItem>) => result.body));
  }
}
